export enum RoleAccessType {
    Restrict = 'restrict',
    Own = 'own',
    OwnAndDep = 'own+dep',
    OwnAndAllUnder = 'own+dep+subdeps',
    All = 'all',
}

export const RoleAccessTypesReferences: { value: RoleAccessType | null; label: string; name: string }[] = [
    { value: RoleAccessType.Restrict, label: 'Нет доступа', name: 'Нет доступа' },
    { value: RoleAccessType.Own, label: 'Только свои', name: 'Только свои' },
    { value: RoleAccessType.OwnAndDep, label: 'Свои и своих отделов', name: 'Свои и своих отделов' },
    // {
    //     value: RoleAccessType.OwnAndAllUnder,
    //     label: 'Свои + своего отдела + подотдела',
    //     name: 'Свои + своего отдела + подотдела',
    // },
    { value: RoleAccessType.All, label: 'Все', name: 'Все' },
];

export const RoleAccessMapping: Record<RoleAccessType, number> = {
    [RoleAccessType.Restrict]: 0,
    [RoleAccessType.Own]: 1,
    [RoleAccessType.OwnAndDep]: 2,
    [RoleAccessType.OwnAndAllUnder]: 3,
    [RoleAccessType.All]: 4,
};

export const getRoleAccessAsReference = (type: RoleAccessType | null | undefined) => {
    if (!type) return null;
    return RoleAccessTypesReferences[RoleAccessMapping[type]];
};
